import React, { useMemo } from 'react';
import { getCoreRowModel, Table, useReactTable } from '@tanstack/react-table';
import { IAnalyticRubricCriterion, IRubric } from '@/components/staffer/ExerciseBuilder/Rubric/useQuestionRubric';
import AnalyticRubric from '@/components/staffer/ExerciseBuilder/Rubric/AddRubricModal/AnalyticRubric';
import {
  AnalyticRubricProps,
} from '@/components/staffer/ExerciseBuilder/Rubric/AddRubricModal/AnalyticRubric/AnalyticRubric';
import {
  createAnalyticRubricColumns,
} from '@/components/staffer/ExerciseBuilder/Rubric/AddRubricModal/AnalyticRubric/AnalyticRubric.utils';
import PreviewCriterionCell
  from '@/components/staffer/ExerciseBuilder/Rubric/AddRubricModal/AnalyticRubric/PreviewCriterionCell';
import PreviewLevelDescriptionCell
  from '@/components/staffer/ExerciseBuilder/Rubric/AddRubricModal/AnalyticRubric/PreviewLevelDescriptionCell';

const DEFAULT_COLUMN_SIZES = { criterion: '300px', level: '200px' };

type AnalyticRubricPreviewProps = {
  analyticRubricProps?: Partial<AnalyticRubricProps>,
  columnSizes?: { criterion?: string, level?: string },
  locale?: Lowercase<Locale>,
  rubric: IRubric,
};

const AnalyticRubricPreview = ({
  analyticRubricProps = {},
  columnSizes = DEFAULT_COLUMN_SIZES,
  locale = 'en',
  rubric,
}: AnalyticRubricPreviewProps) => {
  const analyticColumns = useMemo(
    () => createAnalyticRubricColumns({
      CriterionCell: PreviewCriterionCell,
      LevelCell: PreviewLevelDescriptionCell,
      columnSizes,
      locale,
      scoreLevels: [4, 3, 2, 1],
    }),
    [columnSizes, locale],
  );

  const analyticTable = useReactTable({
    columns: analyticColumns,
    data: rubric.rubric_data as IAnalyticRubricCriterion[],
    getCoreRowModel: getCoreRowModel(),
  });

  return (
    <AnalyticRubric
      hasHeaders={false}
      table={analyticTable as Table<IAnalyticRubricCriterion>}
      {...analyticRubricProps}
    />
  );
};

export default AnalyticRubricPreview;
